/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmContractSourceCodeEntity } from './EvmContractSourceCodeEntity';
import type { EvmProxyContractV2Info } from './EvmProxyContractV2Info';

export type SomniaContractCodeInfo = {
    CNM: string;
    CV: string;
    EV: string;
    OPT: SomniaContractCodeInfo.OPT;
    VD: number;
    PRXINFO: EvmProxyContractV2Info;
    SCLIST: Array<EvmContractSourceCodeEntity>;
    ABI: string;
    DBC: string;
    ISVRFD: SomniaContractCodeInfo.ISVRFD;
    CRTCODE: string;
    BCODE: string;
};

export namespace SomniaContractCodeInfo {

    export enum OPT {
        Y = 'Y',
        N = 'N',
    }

    export enum ISVRFD {
        Y = 'Y',
        N = 'N',
    }


}

